export default "__VITE_ASSET__BQhu2h70__"